const backendHost = "https://my-items.net:8080";

export default backendHost;
